import { render } from "./CustomInfoNoteConfirmation.vue?vue&type=template&id=20dd6235&scoped=true&ts=true"
import script from "./CustomInfoNoteConfirmation.vue?vue&type=script&lang=ts"
export * from "./CustomInfoNoteConfirmation.vue?vue&type=script&lang=ts"

import "./CustomInfoNoteConfirmation.vue?vue&type=style&index=0&id=20dd6235&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20dd6235"]])

export default __exports__